import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  heading: {
    default: 'Confirm',
    editor: 'textbox',
  },
  text: {
    default: 'Are you sure you want to continue? This operation may take a while',
    editor: 'textbox',
  },
  type: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(['information', 'danger', 'warning', 'question']),
  },
  width: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(['small', 'medium', 'large', 'full-screen']),
  },
  height: {
    default: '',
    editor: 'textbox',
  },
  primaryButton: {
    default: '',
    editor: 'textbox',
  },
  cancelButton: {
    default: '',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'An tag-confirm where you can change all the attributes',
  coreComponent: {
    html: `<tag-confirm
  visible{{...knobs}}>
</tag-confirm>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<TagConfirm
  visible{{...knobs}}
/>`,
    knobs: PlaygroundKnobs,
  },
};

export const TagConfirmDocs: Component = {
  type: 'component',
  name: 'confirm',
  description: 'Renders a confirmation dialog',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'visible',
      type: 'boolean',
      description: 'Whether the dialog is shown',
    },
    {
      name: 'type',
      description: 'The type of dialog',
      type: `information' | 'danger' | 'warning' | 'question'`,
      default: 'information',
    },
    {
      name: 'heading',
      type: 'string',
      description: 'The heading text',
    },
    {
      name: 'text',
      type: 'string',
      description: 'The main body of text in the dialog',
    },
    {
      name: 'width',
      description: 'The width of the dialog',
      type: `'small' | 'medium' | 'large' | 'full-screen'`,
      default: 'medium',
    },
    {
      name: 'height',
      description: 'The height of the dialog',
      type: 'string',
    },
    {
      name: 'primaryButton',
      description:
        'The text for the primary button. If this is blank, no primary button will be displayed',
      type: 'string',
    },
    {
      name: 'cancelButton',
      description:
        'The text for the cancel button. If this is blank, no cancel button will be displayed',
      type: 'string',
    },
    {
      name: 'contentStyle',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'opened',
      description: 'Raised when the dialog has opened',
      parameters: [],
    },
    {
      name: 'closed',
      description: 'Raised when the dialog closes',
      parameters: [],
    },
    {
      name: 'primaryButtonClick',
      description: 'Raised when the primary button is clicked',
      parameters: [
        {
          name: 'cancel',
          description: 'A boolean that allows the consumer to cancel the dialog being closed',
          type: 'boolean',
        },
      ],
    },
    {
      name: 'cancelButtonClick',
      description: 'Raised when the cancel button is clicked',
      parameters: [
        {
          name: 'cancel',
          description: 'A boolean that allows the consumer to cancel the dialog being closed',
          type: 'boolean',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'show',
      description: 'Shows the modal dialog',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'hide',
      description: 'Hides the modal dialog',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory],
};
